import * as yup from 'yup';

export const surgerySchema = yup.object({
    name: yup.string().label('name').required('Este campo es requerido'),
});

export type surgerySchemaType = yup.InferType<typeof surgerySchema>
